import React from "react"
import { Link } from "react-router-dom"
import { motion } from "framer-motion"
import imgMain from "../../Assets/campus2.jpg"
import imgSecondary from "../../Assets/campus3.jpg"

const stats = [
	{ value: "+1 & +2", label: "Integrated academics" },
	{ value: "5+", label: "Career pathways" },
	{ value: "NEET/JEE", label: "Coaching integrated" },
	{ value: "100%", label: "Residential campus" },
]

const features = [
	{ icon: "ri-graduation-cap-line", color: "#174e4a", label: "Academic Excellence" },
	{ icon: "ri-award-line", color: "#c4935a", label: "Entrance Coaching" },
	{ icon: "ri-global-line", color: "#3a2942", label: "Global Pathways" },
]

const About = () => {
	return (
		<div className="about-section-new">
			<div className="container-main">
				<div className="about-new-inner">
					<motion.div
						className="about-new-text"
						initial={{ opacity: 0, x: -30 }}
						whileInView={{ opacity: 1, x: 0 }}
						viewport={{ once: true }}
						transition={{ duration: 0.7 }}
					>
						<span className="about-new-eyebrow">Who We Are</span>
						<h2 className="about-new-heading montserrat">
							Branmont{" "}
							<span className="about-new-highlight">Global Secondary School</span>
						</h2>
						<p className="about-new-desc">
							A career-integrated senior secondary institution for boys, focused on building confident, capable, and globally competitive young men. We combine academic excellence, entrance coaching, professional courses, and global exposure in a safe and empowering environment.
						</p>
						<div className="about-new-features">
							{features.map(f => (
								<div className="about-new-feature-item" key={f.label}>
									<div
										className="about-new-feature-icon"
										style={{ background: f.color + "1a", color: f.color }}
									>
										<i className={f.icon}></i>
									</div>
									<span>{f.label}</span>
								</div>
							))}
						</div>
						<Link className="about-new-btn" to="/about">
							Discover Our Story <i className="ri-arrow-right-line"></i>
						</Link>
					</motion.div>

					<motion.div
						className="about-new-media"
						initial={{ opacity: 0, x: 30 }}
						whileInView={{ opacity: 1, x: 0 }}
						viewport={{ once: true }}
						transition={{ duration: 0.7, delay: 0.1 }}
					>
						<div className="about-new-img-main">
							<img src={imgMain} alt="Branmont campus students" />
						</div>
						<div className="about-new-img-secondary">
							<img src={imgSecondary} alt="Students studying" />
						</div>
					
					</motion.div>
				</div>

				<div className="about-new-stats">
					{stats.map((stat, i) => (
						<motion.div
							className="about-new-stat-item"
							key={stat.label}
							initial={{ opacity: 0, y: 20 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true }}
							transition={{ duration: 0.5, delay: i * 0.07 }}
						>
							<strong>{stat.value}</strong>
							<span>{stat.label}</span>
						</motion.div>
					))}
				</div>
			</div>
		</div>
	)
}

export default About
